export const trimValues = (obj) => {
  const trimmed = {};
  for (const key in obj) {
    if (typeof obj[key] === "string") {
      trimmed[key] = obj[key].trim();
    } else {
      trimmed[key] = obj[key]; // ostavi kakvo jeste ako nije string
    }
  }
  return trimmed;
};
